module.exports = __webpack_public_path__ + "static/media/0.be5b39ac.jpeg";